import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { FT_PI_BB_NON_GUARANTEED_REMINDER } from '@whitbread-eos/api';
import { formatDataTestId, renderSanitizedHtml, getBookingConfirmationMessage, useFeatureToggle, useSemanticTypography } from '@whitbread-eos/utils';
import { useRouter } from 'next/router';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function ThanksForBooking(_ref) {
  var data = _ref.data,
    t = _ref.t,
    currentLang = _ref.currentLang,
    _ref$sendMail = _ref.sendMail,
    sendMail = _ref$sendMail === void 0 ? true : _ref$sendMail;
  var router = useRouter();
  var getTypographyProps = useSemanticTypography();
  var _useFeatureToggle = useFeatureToggle(),
    isSecureBookingFeatureEnabled = _useFeatureToggle[FT_PI_BB_NON_GUARANTEED_REMINDER];
  var thanksForBooking = data.thanksForBooking;
  var baseDataTestId = 'ThanksForBooking';
  if (!thanksForBooking) {
    return null;
  }
  var confirmationMessage = getBookingConfirmationMessage(t, router === null || router === void 0 ? void 0 : router.query, isSecureBookingFeatureEnabled);
  var title = thanksForBooking.title,
    lastName = thanksForBooking.lastName,
    firstName = thanksForBooking.firstName,
    emailAddress = thanksForBooking.emailAddress;
  return _jsxs(Box, _objectSpread(_objectSpread({
    "data-testid": formatDataTestId(baseDataTestId, 'Container')
  }, contentWrapperStyle), {}, {
    sx: {
      '@media print': {
        display: 'none'
      }
    },
    children: [_jsxs(Text, _objectSpread(_objectSpread(_objectSpread({
      className: "sessioncamhidetext assist-no-show"
    }, titleLayoutStyles), getTypographyProps(titleLegacyTypography, titleSemanticTypography)), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'Title-Name'),
      children: [confirmationMessage, " ", currentLang !== 'en' ? "".concat(title, " ").concat(lastName) : firstName]
    })), emailAddress && sendMail && _jsx(Text, _objectSpread(_objectSpread({
      className: "sessioncamhidetext assist-no-show",
      "data-testid": formatDataTestId(baseDataTestId, 'Email')
    }, getTypographyProps(emailConfirmationLegacyTypography, emailConfirmationSemanticTypography)), {}, {
      children: renderSanitizedHtml(t('booking.confirmation.confirmationEmailMessage').replace('[emailAddress]', emailAddress))
    }))]
  }));
}
var contentWrapperStyle = {
  w: 'full'
};
var titleLayoutStyles = {
  mb: 'md'
};
var titleLegacyTypography = {
  fontSize: '3xxl',
  fontWeight: 'semibold'
};
var titleSemanticTypography = {
  textStyle: 'heading-xl'
};
var emailConfirmationLegacyTypography = {
  fontSize: 'md'
};
var emailConfirmationSemanticTypography = {
  textStyle: 'body-m-regular'
};